import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    // LEXUS问题详情
    path: '/lexus/commonProblems',
    name: 'lexusCommonProblems',
    component: () =>
      import(
        /* webpackChunkName: "lexusCommonProblems" */ '@/views/lexus/help-center/HelpCenter.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    // LEXUS问题详情
    path: '/lexus/commonProblems/detail',
    name: 'lexusCommonProblemsDetail',
    component: () =>
      import(
        /* webpackChunkName: "lexusCommonProblemsDetail" */ '@/views/lexus/help-center/QuestionDetail.vue'
      ),
    meta: {
      cname: '问题详情'
    }
  },
  {
    // LEXUS用户协议
    path: '/lexus/paRegist',
    name: 'lexusPaRegist',
    component: () => import(/* webpackChunkName: "lexusPaRegist" */ '@/views/lexus/Agreements.vue'),
    meta: {
      cname: '用户协议'
    }
  },
  {
    // 本田数字钥匙安装说明书
    path: '/lexus/ins',
    name: 'lexusIns',
    component: () =>
      import(
        /* webpackChunkName: "lexusIns" */ '@/views/brand-building/lexus/instruction/InstallBook.vue'
      ),
    meta: {
      cname: '雷克萨斯SKB数字钥匙升级安装指导'
    }
  },
  {
    // 本田数字钥匙安装说明书列表
    path: '/lexus/ins/list',
    name: 'lexusInsList',
    component: () =>
      import(
        /* webpackChunkName: "lexusInsList" */ '@/views/brand-building/lexus/instruction/BookList.vue'
      ),
    meta: {
      cname: '雷克萨斯安装指导'
    }
  },
  {
    // 本田数字钥匙安装视频说明书
    path: '/lexus/ins/video',
    name: 'lexusInsVideo',
    component: () =>
      import(
        /* webpackChunkName: "lexusInsVideo" */ '@/views/brand-building/lexus/instruction/BookVideo.vue'
      ),
    meta: {
      cname: '雷克萨斯安装指导'
    }
  },
  {
    // 本田数字钥匙安装视频说明书
    path: '/lexus/ins/pdf',
    name: 'lexusInsPdf',
    component: () =>
      import(
        /* webpackChunkName: "lexusInsPdf" */ '@/views/brand-building/lexus/instruction/BookPdf.vue'
      ),
    meta: {
      cname: '雷克萨斯SKB数字钥匙升级安装指导'
    }
  },
  {
    path: '/lexus/intelligent-unlocking',
    name: 'intelligentUnlockingWithAppLEXUS',
    component: () =>
      import(/* webpackChunkName: "SmartLockerManualLEXUS" */ '@/views/lexus/SmartLockerManual.vue'),
    meta: {
      cname: '智能解闭锁'
    },
    props: true
  }
];
export default routes;
